// We need jQuery
var $ = window.jQuery;

// Import svg4everybody
import svg4everybody from 'svg4everybody';

// Import Cookies
import Cookies from 'js-cookie';

// Import stickyfill
var Stickyfill = require('stickyfill-web-module')();

// Headroom
import Headroom from 'headroom.js/dist/headroom.js';
window.Headroom = Headroom;

// Headroom jQuery
import 'headroom.js/dist/jQuery.headroom.js';

// for shared pages
import mapSingleMarker from '../../../brochure-theme-shared/assets/scripts/routes/shared/map-single-marker';
import flickitySliders from '../../../brochure-theme-shared/assets/scripts/routes/shared/flickity-sliders';
import commonModal from '../shared/common-modal';
import participantDetails from '../shared/participant-details';

export default {
  init() {
    // JavaScript to be fired on all pages
    // Headroom JS
    $("nav.headroom").headroom();

    //Iniitalize svg4everybody
    svg4everybody();

    // List for notication close
    $('#tofino-notification .close').on('click', function() {
      if (tofinoJS.cookieExpires) {
        Cookies.set('tofino-notification-closed', 'yes', {expires: parseInt(tofinoJS.cookieExpires)});
      } else {
        Cookies.set('tofino-notification-closed', 'yes');
      }
    });

    // Show the notfication using JS based on the cookie (fixes html caching issue)
    if (tofinoJS.notificationJS === 'true' && !Cookies.get('tofino-notification-closed')) {
      $('#tofino-notification').show();
    }

    // Assign sticky
    var $sticky = document.getElementsByClassName('sticky-top');
    if ($sticky.length) {
      Stickyfill.add($sticky[0]);
    }

    // acf.add_action('wysiwyg_tinymce_init', function( ed, id, mceInit, $field ){
    //   ed.settings.disable_native_spell_checker = false;
    // });
    mapSingleMarker();
    commonModal();
    participantDetails();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.alert:not(.nd-able)').append('<span></span>');
    $('.alert:not(.nd-able) span').on('click', function(){
      $(this).closest('.alert').remove();
    })

    flickitySliders();
  },
  loaded() {
    // Javascript to be fired on page once fully loaded
    $('form#star').each(function () {
      if ($(this).find('.hold-state').val() == 'true') {
        $(this).find('label').addClass('on');
      }
      if ($(this).find('.hold-state').val() == 'false') {
        $(this).find('label').removeClass('on');
      }
    });

    $('form#star').on('submit', function () {
      var star = $(this);
      $('.loading').show();
      $(star).find('label').toggleClass('on');
      $.ajax({
        url: tofinoJS.ajaxUrl,
        type: 'POST',
        data: {
          action: 'submitStar',
          value: {
            post_id: $(this).data('id')
          }
        },
        dataType: 'json',
        success: function (response) {
          if (response.success) {
            $(star).find('.hold-state').val(response.state);
            $('.loading').hide();
          }
        }
      });
    })
  }
};
